import { render, staticRenderFns } from "./UpdateAltCoinXChangeAddressPoolModal.vue?vue&type=template&id=2d821dfc&scoped=true&"
import script from "./UpdateAltCoinXChangeAddressPoolModal.vue?vue&type=script&lang=js&"
export * from "./UpdateAltCoinXChangeAddressPoolModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d821dfc",
  null
  
)

export default component.exports